import React from 'react';
import { useTranslation } from 'react-i18next';

import { Box } from '@mui/material';
import clsx from 'clsx';
import { useGetDimensionalityOptions } from 'constants/businessTool';

import { useGetCurrencySymbol } from 'hooks/useGetCurrencySymbol';

import { SelectComponentControl } from 'components/_basic/SelectComponent/SelectComponentControl';

import { ICurrencySelectorProps } from './types';

import styles from './CurrencySelector.module.scss';

export const CurrencySelector: React.FC<ICurrencySelectorProps> = ({ name, disabled, ...restProps }) => {
  const { t } = useTranslation();
  const currencySymbol = useGetCurrencySymbol();
  const DIMENSIONALITY_OPTIONS = useGetDimensionalityOptions();

  return (
    <Box className={styles.selectContainer} {...restProps}>
      <Box className={clsx(styles.selectTitle, { [styles.disabled]: disabled })}>
        {t('currencySelector', { currency: currencySymbol })}
      </Box>
      <SelectComponentControl
        disabled={disabled}
        id={name}
        name={name}
        options={DIMENSIONALITY_OPTIONS}
        defaultValue={DIMENSIONALITY_OPTIONS[0]}
      />
    </Box>
  );
};
